export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ16.c7abe341.mp3";